import { action } from 'satcheljs';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { addDatapointConfig } from 'owa-analytics-actions';
import { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

/**
 * Intializes the compose store with a duplicate of the given event
 */
export let duplicateEvent = action(
    'duplicateEvent',
    (
        event: CalendarEvent,
        entrySource: FullComposeEntrySourceType,
        viewType: FullComposeFormViewType,
        useDefaultScope?: boolean
    ) =>
        addDatapointConfig(
            {
                name: 'DuplicateEvent',
                customData: {
                    owa_1: entrySource,
                },
            },
            {
                event,
                entrySource,
                useDefaultScope,
                viewType,
            }
        )
);
